export default {
    key: 'joch-epr',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    origins: [],
    destinations: [{
        ref: 'urn:uic:stn:8507364',
        name: 'Jungfraujoch – Top of Europe',
    }],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: true,
    canSwitchDirection: false,
    canChooseReturnDestination: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: 'only',
    routeVariants: ['express', 'traditional-grin', 'traditional-laut'],
    routeVariantUp: 'default-jungfraujoch',
    routeVariantDown: 'default-jungfraujoch',
    upsells: [],
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 30,
    maxNumberOfPeople: 9,
    maxNumberOfPeopleGroupTariff: 10,
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:ts:listing:aca57c78-6366-41a7-bd74-cdfb799b2135',
    contentfulId: 'joch-epr',
    steps: [],

} satisfies ProductConfigP2P;
